import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ProductCollapseHeader from './ProductCollapseHeader';
import { useProductCollapseDesktopStyles } from './styles';

const ProductCollapseDesktop = ({ ...props }) => {
  const {
    index,
    children,
    dataCy,
    name,
    totalPrice,
    dateText,
    purchaseDate,
    isMkp,
    isOpen,
    somethingBelow,
    mouseOver,
  } = props;
  const [expanded, setExpanded] = useState(false);
  const classes = useProductCollapseDesktopStyles({ expanded, somethingBelow });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (index < 2) setExpanded('panel1');
  }, [index]);

  useEffect(() => {
    isOpen(expanded);
  }, [expanded]);

  return (
    <Accordion
      className={classes.accordion}
      expanded={expanded == 'panel1'}
      onChange={handleChange('panel1')}
      elevation={0}
      data-cy={dataCy || 'productContainer'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.accordionDivider}
        data-cy="summary"
      >
        <ProductCollapseHeader
          name={name}
          totalPrice={totalPrice}
          dateText={dateText}
          purchaseDate={purchaseDate}
          isMkp={isMkp}
          expanded={expanded}
          mouseOver={mouseOver}
        />
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

ProductCollapseDesktop.propTypes = {
  index: PropTypes.number,
  children: PropTypes.node,
  dataCy: PropTypes.string,
  name: PropTypes.string,
  totalPrice: PropTypes.number,
  purchaseDate: PropTypes.string,
  isMkp: PropTypes.bool,
  isOpen: PropTypes.func,
  somethingBelow: PropTypes.bool,
  dateText: PropTypes.string,
  mouseOver: PropTypes.bool,
};

export default ProductCollapseDesktop;
